// import _ from 'lodash'
import vm from '../main'

const internals = {}


internals.addStaff = function (staff) {
    // Filter out properties not needed

    staff = (({
        firstName,
        lastName,
        email,
        phoneNumber,
        roleType,
        documents,

    }) => {
        return {
            firstName,
            lastName,
            email,
            phoneNumber,
            roleType,
            documents,
        }
    })(staff)

    return vm.$staffDataRepository
        .create(staff)
        .then(result => {
            staff = result.data
            return staff

        })
        .catch(error => {
            console.error('deviceService.createRole-error:\n', error)
            throw error
        })
}



export default internals


// WEBPACK FOOTER //
// ./src/services/staff.service.js